import { createActionGroup, emptyProps, props } from '@ngrx/store'

import {
  CheckProcessResponse,
  CheckUIResponse,
  ExtractComplianceFromDocumentResponse,
} from '@flowx/designer/modules/new-ai/agents/auditor/api/auditor.api'
import {
  DocumentContextReference,
  SendFeedbackPayload,
} from '@flowx/designer/modules/new-ai/common/ai.dictionary'

const errorProps = props<{ statusCode: number; errorMsg?: any }>

export const AiAuditorActions = createActionGroup({
  source: 'AiAuditor',
  events: {
    checkProcess: props<{ prompt: string }>(),
    checkProcessSuccess: props<{
      response: CheckProcessResponse
    }>(),
    checkProcessFailure: props<{ error?: any }>(),

    checkUI: props<{ prompt: string }>(),
    checkUISuccess: props<{
      response: CheckUIResponse
    }>(),
    checkUIFailure: errorProps(),

    // SSE-mode equivalents — preferred path. The chat endpoint streams
    // graph events; per-chunk forwarding via getAnswerEventStream lets
    // the chat panel render incremental output.
    checkProcessStream: props<{ prompt: string }>(),
    checkUIStream: props<{ prompt: string }>(),
    getAnswerEventStream: props<{ response: any }>(),
    streamCompleted: emptyProps(),
    extractComplianceFromDocument: props<{
      documentContextReference: DocumentContextReference
      context: any
    }>(),
    extractComplianceFromDocumentSuccess: props<{
      response: ExtractComplianceFromDocumentResponse
    }>(),
    extractComplianceFromDocumentFailure: errorProps(),

    discardAuditDraft: emptyProps(),

    sendFeedback: props<{ payload: SendFeedbackPayload }>(),
  },
})
